import { faFileSignature } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Avatar,
  Button,
  CardActions,
  CardContent,
  CardHeader,
  makeStyles,
  Typography,
  useTheme
} from '@material-ui/core'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import ButtonWithPermissions from '../../../../../components/buttonWithPermissions/buttonWithPermissions'
import { CardWithTransition } from '../../../../../components/shared/cardWithTransition/CardWithTransition'
import { LoadingCard } from '../../../../../components/shared/loadingCard/loadingCard'
import { ButtonOption } from '../../../../../components/shared/splitButton/splitButton'
import { NonAuthRoutes } from '../../../../../model'

import { EmptyContent } from '../shared/emptyCard'

import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { ProceduresTable } from '../../../../../components/shared/proceduresTable/proceduresTable'
import useProcedures from '../../../../../components/shared/proceduresTable/proceduresTable.hooks'
import { useShowGoToProcedures } from '../../../../../hooks/useShowGoToProceduresDialog'
import { ProcedureFormMode } from '../../../../procedures/procedures.types'
import { styles } from './proceduresCard.styles'
import { ProceduresCardProps } from './proceduresCard.types'

export const ProceduresCard: React.FC<ProceduresCardProps> = ({
  clientID,
  error,
  // onClickAdd,
  // onClickEdit,
  onRetry,
  refreshComponent
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'clientFile', 'enums'])
  const history = useHistory()

  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const { getShowGoToProceduresDialog } = useShowGoToProcedures()

  const {
    procedures,
    procedure,
    setProcedure,
    isFetchingProcedures,
    isFetchingProcedure,
    refreshProcedures
  } = useProcedures({ clientID })

  const ProceduresHeader = () =>
    React.useMemo(() => {
      return (
        <CardHeader
          className={classes.cardheader}
          avatar={
            <Avatar>
              <FontAwesomeIcon size={'lg'} icon={faFileSignature as IconProp} />
            </Avatar>
          }
          title={
            <Typography className={classes.cardTitle} color={'secondary'}>
              {t('clientFile:components.proceduresCard.title')}
            </Typography>
          }
        />
      )
    }, [t])

  if (error) {
    return (
      <CardWithTransition show={true} raised>
        <ProceduresHeader />
        <EmptyContent title={t('clientFile:components.proceduresCard.errorCard.errorMessage')}>
          <ButtonWithPermissions
            hasPermission={true}
            size="small"
            color="primary"
            variant="contained"
            onClick={onRetry}
          >
            {t('clientFile:components.proceduresCard.errorCard.buttonLabel')}
          </ButtonWithPermissions>
        </EmptyContent>
      </CardWithTransition>
    )
  }

  const handleClickAdd = (option: ButtonOption) => {
    // onClickAdd(option)
  }

  useEffect(() => {
    if (refreshComponent) {
      refreshProcedures()
    }
  }, [refreshComponent])

  if (isFetchingProcedures) {
    return <LoadingCard />
  }

  return (
    <CardWithTransition show={true} raised>
      {!error && procedures && procedures.length > 0 ? (
        <>
          <CardContent className={classes.cardContent}>
            <ProceduresTable
              className={classes.dataTableWithoutHeader}
              title={<ProceduresHeader />}
              procedures={procedures}
              procedure={procedure}
              onSelectProcedure={setProcedure}
              onRefreshProcedures={refreshProcedures}
              onNotificationChange={p => {}}
              cardMode
            />
          </CardContent>
          <CardActions className={classes.cardActionsRight}>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() =>
                history.push(NonAuthRoutes.ProceduresAdd, {
                  formMode: ProcedureFormMode.GENERAL
                })
              }
            >
              {t('clientFile:components.proceduresCard.actions.create')}
            </Button>
          </CardActions>
        </>
      ) : (
        <EmptyContent title={t('clientFile:components.proceduresCard.emptyCard.title')}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() =>
              history.push(NonAuthRoutes.ProceduresAdd, {
                formMode: ProcedureFormMode.GENERAL
              })
            }
          >
            {t('clientFile:components.proceduresCard.actions.create')}
          </Button>
        </EmptyContent>
      )}
    </CardWithTransition>
  )
}
